import { ButtonHTMLAttributes, ReactNode } from "react";

interface DashboardButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost";
  icon?: ReactNode;
}

export function DashboardButton({
  variant = "primary",
  className = "",
  icon,
  children,
  ...props
}: DashboardButtonProps) {
  const baseClasses =
    "typography-button inline-flex min-h-8 items-center justify-center gap-1.5 rounded-lg border px-3 py-2 tracking-tight transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400/70 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950 disabled:cursor-not-allowed disabled:opacity-60";

  const variantClass = variant === "primary"
    ? "dashboard-btn-primary"
    : variant === "secondary"
    ? "dashboard-btn-secondary"
    : "";

  const variantClasses = {
    primary:
      "border-sky-500/10 bg-sky-500 text-white shadow-[0_12px_24px_rgba(59,130,246,0.18)] hover:bg-sky-400",
    secondary:
      "border-white/10 bg-white/5 text-slate-100 hover:border-slate-300/20 hover:bg-white/10",
    ghost: "border-transparent bg-transparent text-slate-100 hover:bg-white/5",
  }[variant];

  return (
    <button
      className={`${baseClasses} ${variantClasses} ${variantClass} ${className}`.trim()}
      {...props}
      data-oid="bfkjko3"
    >
      {icon}
      {children}
    </button>
  );
}
